import * as views from './pages'

angular.module('app.formalizacao').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.formalizacao', {
            abstract: true
        })
        .state('app.formalizacao.ccbreprocessamentocopia', {
            url: '/processos/ccb/reprocessamentocopia',
            views: {
                'content@app': lazyLoadProvider.create(views.ccbReprocessamentoCopia)
            },
            data: {
                title: 'Reprocessamento Cópia CCB',
                access: { requiredPermissions: ['backoffice'] },
                breadcrumbs: ['Processos', 'CCB', 'Reprocessamento Copia']
            }
        })
        .state('app.formalizacao.consultaproposta', {
            url: '/consultas/proposta',
            views: {
                'content@app': lazyLoadProvider.create(views.consultaProposta)
            },
            data: {
                title: 'Propostas',
                access: { requiredPermissions: ['backoffice'] },
                breadcrumbs: ['Consultas', 'Propostas']
            }
        })
        .state('app.formalizacao.consultapropostadetalhe', {
            url: '/consultas/proposta/detalhe?codigo',
            views: {
                'content@app': lazyLoadProvider.create(views.consultaPropostaDetalhe)
            },
            data: {
                title: 'Detalhe da Proposta',
                access: { requiredPermissions: ['backoffice'] },
                breadcrumbs: ['Consultas', 'Propostas', 'Detalhe']
            }
        })
});